import { CanvasLayer } from 'src/app/global/interfaces/canvas-layer';
import { InteractionType } from 'src/app/predictor/enums/interaction-type';
import { TerrainLoadingStatus } from 'src/app/predictor/enums/terrain-loading-status';
import { AgentSettings } from 'src/app/predictor/interfaces/agent-settings';
import { TerrainInspectDetails } from 'src/app/predictor/models/TerrainInspectDetails';
import { TerrainRenderingStatus } from '../../predictor/enums/terrain-rendering-status';
import { ConfigurationProfileWrite } from '../../predictor/interfaces/configuration-profile-write';

export namespace PredictorModelActions {
  export class SetExporting {
    static readonly type = `[Predictor Model] set exporting`;
    constructor(public isExporting: boolean) {}
  }

  export class UnselectStudyArea {
    static readonly type = `[Predictor Model] remove study area`;
  }

  export class OpenStudyAreaDropdown {
    static readonly type = `[Predictor Model] open study area dropdown`;
  }

  export class ResetToDefaults {
    static readonly type = `[Predictor Model] reset to defaults`;
  }

  export class SetTerrainState {
    static readonly type = `[Predictor Model] set terrain state`;
    constructor(public state: string, public status: TerrainRenderingStatus) {}
  }

  export class SetDetailVisibility {
    static readonly type = `[Predictor Model] set detail visibility`;
    constructor(public showDetails: boolean) {}
  }

  export class SetTerrainLoadingStatus {
    static readonly type = `[Predictor Model] set terrain loading status`;
    constructor(public terrainLoadingStatus: TerrainLoadingStatus) {}
  }

  export class SetCanvasVisibility {
    static readonly type = `[Predictor Model] set canvas visibility`;
    constructor(public showCanvas: boolean) {}
  }

  export class AddShapeFile {
    static readonly type = `[Predictor Model] add shapefile`;
    constructor(public shapeFile: CanvasLayer) {}
  }

  export class AddFishnetShapeFileName {
    static readonly type = `[Predictor Model] add fishtnet shapefile name`;
    constructor(public fileName: string) {}
  }

  export class DeleteShapeFile {
    static readonly type = `[Predictor Model] delete shapefile`;
    constructor(public shapeFileToRemove: CanvasLayer) {}
  }

  export class UpdateShapeFiles {
    static readonly type = `[Predictor Model] update shapefiles`;
    constructor(public shapeFiles: CanvasLayer[]) {}
  }

  export class SetSelectedShapeFile {
    static readonly type = `[Predictor Model] set selected shapefile`;
    constructor(public shapefile: CanvasLayer) {}
  }

  export class AddScenario {
    static readonly type = `[Predictor Model] add scenario`;
    constructor(public scenario: CanvasLayer) {}
  }

  export class UpdateScenarios {
    static readonly type = `[Predictor Model] update scenarios`;
    constructor(public scenarios: CanvasLayer[]) {}
  }

  export class DeleteScenario {
    static readonly type = `[Predictor Model] delete scenario`;
    constructor(public scenarioToRemove: CanvasLayer) {}
  }

  export class UploadDEMFile {
    static readonly type = `[Predictor Model] upload dem file`;
    constructor(public file: File) {}

    static readonly success = 'DEM file uploaded successfully.';
    static readonly error = 'An error occurred uploading DEM file.';
  }

  export class SetInspectDetails {
    static readonly type = `[Predictor Model] set inspectDetails`;
    constructor(public inspectDetails: TerrainInspectDetails) {}
  }

  export class SetInteractionType {
    static readonly type = `[Predictor Model] set interactionType`;
    constructor(public interactionType: InteractionType) {}
  }

  export class GetConfigurationProfiles {
    static readonly type = `[Predictor Model] get configuration profiles`;
  }

  export class CreateConfigurationProfile {
    static readonly type = `[Predictor Model] create configuration profile`;
    constructor(public configurationProfile: ConfigurationProfileWrite) {}

    static readonly success = 'Configuration profile saved.';
    static readonly error = 'An error occurred creating configuration profile.';
  }

  export class DeleteConfigurationProfile {
    static readonly type = `[Predictor Model] delete configuration profile`;
    constructor(public configurationId: string) {}

    static readonly success = 'Configuration profile deleted.';
    static readonly error = 'An error occurred deleting configuration profile.';
  }

  export class UpdateAgentSettings {
    static readonly type = `[Predictor Model] set agent settings`;
    constructor(
      public agentSettings: AgentSettings,
      public simulationId: string
    ) {}

    static readonly success = 'Agent settings updated successfully.';
    static readonly error = 'An error occurred updating agent settings.';
  }

  export class ResetAgentSettings {
    static readonly type = `[Predictor Model] reset agent settings`;
  }

  export class TerrianFileUploadCheck {
    static readonly type = `[Predictor Model] file upload check`;
    constructor(public terrainId: string, public poll: boolean = false) {}
  }

  export class TerrianFileUploadComplete {
    static readonly type = `[Predictor Model] file upload complete`;
    constructor(public simulationId: string) {}
  }

  export class GetStudyAreas {
    static readonly type = `[Predictor Model] get study areas`;
  }

  export class SetSelectedStudyArea {
    static readonly type = `[Predictor Model] set selected study area`;
    constructor(public id: string, public name: string,public licenseNumber:string|null) {}

    static readonly error = 'An error occurred getting study area.';
  }

  export class StudyAreaTerrainReady {
    static readonly type = `[Predictor Model] study area terrain ready`;
    constructor(
      public simulationId: string,
      public status: TerrainLoadingStatus
    ) {}
  }
}
